import { Component, OnInit, signal } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";
import { Observable, of } from "rxjs";
import {
  LEVEL_PUBLISHED,
  PARAM_PAGES_PATH,
  STATE_LIST,
  STATE_PAGES_PUBLISHED,
  STATE_PUBLISHED,
  TEMPLATE_PAGES,
  TEMPLATE_PUBLISHED,
} from "src/app/admin/constants/constants";
import { AbstractFormComponent } from "src/app/common/abstract-edit.component";
import { Pages } from "src/app/models/pages";
import { PagesService } from "src/app/services/pages.service";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { EditorModule } from "primeng/editor";
import { SharedModule } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { ReactiveFormsModule } from "@angular/forms";
import { Ripple } from "primeng/ripple";
import { RouterLink } from "@angular/router";
import { SelectButtonModule } from "primeng/selectbutton";
import { SelectModule } from "primeng/select";
import { TabsModule } from "primeng/tabs";
import { ToastModule } from "primeng/toast";
import { TopNavComponent } from "../../../top-nav/top-nav.component";
import { UploadComponent } from "../../components/upload/upload.component";
import { UploadFilesComponent } from "../../components/upload-files/upload-files.component";
import { UploadNewsComponent } from "../../components/upload-news/upload-news.component";

@Component({
    selector: "app-pages-form",
    templateUrl: "./pages-form.component.html",
    imports: [ButtonModule, CardModule, ConfirmDialogModule, EditorModule, SharedModule, FormsModule, InputTextModule, ReactiveFormsModule, Ripple, RouterLink, SelectButtonModule, SelectModule, TabsModule, ToastModule, TopNavComponent, UploadComponent, UploadFilesComponent, UploadNewsComponent]
})
export class PagesFormComponent
  extends AbstractFormComponent<Pages>
  implements OnInit
{
  pageTitle = signal("");
  form: FormGroup;
  idField = "id";
  formFields = [
    "id",
    "page_title",
    "page_url",
    "page_seotitle",
    "page_seodescription",
    "description_1",
    "description_2",
    "description_3",
    "page_order",
    "mother_page_id",
    "status",
    "page_template",
    "is_active",
  ];

  item$: Observable<Pages> = of(); // Initialize with an empty Observable
  stateOptions = STATE_LIST;
  service = this.pagesService; // Implement the abstract service property
  element = signal<Pages | null>(null);
  selectedStatePublished: SelectItem[] = [];
  selectedTemplatePublished: SelectItem[] = [];
  selectedLevelPublished: SelectItem[] = [];
  statePublished = STATE_PAGES_PUBLISHED;
  levelPublished: any[];
  selectedPagesPublished: Pages[];
  pages: Pages[] = [];
  templatePublished: any[];
  templatesPages: any[];

  constructor(
    protected fb: FormBuilder,
    private pagesService: PagesService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute
  ) {
    super(
      fb,
      messageService,
      confirmationService,
      router,
      route,
      PARAM_PAGES_PATH
    );

    this.stateOptions = STATE_LIST;
  }

  ngOnInit() {
    this.initializeForm();
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle.set("Modifica Pagina");
      this.loadItem(+id);
      this.loadPages();
    } else {
      this.pageTitle.set("Aggiungi Pagina");
      this.loadPages();
    }

    this.templatesPages = TEMPLATE_PAGES;
    this.templatePublished = TEMPLATE_PUBLISHED;
    this.levelPublished = LEVEL_PUBLISHED;
  }

  loadPages(): void {
    const params = {
      page: 0,
      size: 1000,
    };
    this.pagesService.list(params).subscribe((pData) => {
      this.pages = pData;
    });
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [""],
      page_title: ["", Validators.required],
      page_template: [""],
      page_url: [""],
      description_1: [""],
      description_2: [""],
      description_3: [""],
      page_seotitle: [""],
      mother_page_id: [0],
      page_order: [""],
      page_seokeywords: [""],
      page_seodescription: [""],
      level: [""],
      status: [""],
      is_active: ["0"],
    });
  }

  loadItem(id: number) {
    this.service.getId(id).subscribe(
      (res) => {
        this.element.set(res);
        this.form.patchValue({
          page_title: res.page_title,
          page_template: res.page_template,
          page_url: res.page_url,
          description_1: res.description_1,
          description_2: res.description_2,
          description_3: res.description_3,
          page_seotitle: res.page_seotitle,
          page_seokeywords: res.page_seokeywords,
          mother_page_id: res.mother_page_id,
          page_seodescription: res.page_seodescription,
          page_order: res.page_order,
          status: res.status,
          is_active: res.is_active,
          id: res.id,
        });
      },
      (error) => (this.error.set(error))
    );
  }
}
